import Accordion from "components/accordion/Accordion";
import DailyReportCard from "components/card/DailyReportCard";
import { CreateAppealRequestPopup } from "components/pop-up/AppealRequest";
import { useMemo, useState } from "react";

import { AssetAppeal, Report } from "types";

export default function ReportList({
  referralId,
  fileRowProps,
  reports,
  appeal,
  handleReportDataUpdated,
}: {
  referralId?: string;
  fileRowProps: any;
  reports: Report[];
  appeal?: AssetAppeal;
  handleReportDataUpdated?: () => void;
}) {
  // Filter prohibition reports by type
  const prohibitionDailyReports = reports.filter(
    (report) => !report.is_next_appointment_reason_final_verdict,
  );
  const prohibitionFinalVerdicts = reports.filter(
    (report) => report.is_next_appointment_reason_final_verdict,
  );

  const [isAppealPopupOpen, setIsAppealPopupOpen] = useState<{
    open: boolean;
    data: any;
  }>({ open: false, data: null });
  const allFinalReportAssets = useMemo(() => {
    const assets: any[] = [];
    prohibitionFinalVerdicts.forEach((report) => {
      if (report.asset) {
        if (Array.isArray(report.asset)) {
          assets.push(...report.asset);
        } else if (typeof report.asset === "object") {
          assets.push(report.asset);
        }
      }
    });
    return assets;
  }, [prohibitionFinalVerdicts]);

  return (
    <div className="max-w-3xl bg-gray-50 rounded-xl shadow-sm w-[55%] p-2 mt-2">
      <div className="space-y-2">
        {/* Prohibition Daily Reports */}
        {prohibitionDailyReports.length > 0 && (
          <Accordion
            title={`Prohibition Daily Reports (${prohibitionDailyReports.length})`}
            mainTitle=""
          >
            <div className="space-y-2">
              {prohibitionDailyReports.map((report, index) => (
                <Accordion
                  key={report.id}
                  title={`Daily Report - ${new Date(
                    report.court_hearing_date,
                  ).toLocaleDateString(undefined, {
                    weekday: "long",
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  })}`}
                  mainTitle=""
                >
                  <DailyReportCard
                    key={report.id || index}
                    report={report}
                    fileRowProps={fileRowProps}
                    prohibitionId={report.prohabition_request}
                  />
                </Accordion>
              ))}
            </div>
          </Accordion>
        )}

        {/* Prohibition Final Verdicts */}
        {prohibitionFinalVerdicts.length > 0 && (
          <Accordion
            title={`Prohibition Final Verdicts (${prohibitionFinalVerdicts.length})`}
            mainTitle=""
          >
            <div className="space-y-2">
              {prohibitionFinalVerdicts.map((report, index) => (
                <Accordion
                  key={report.id}
                  title={`Final Verdict - ${new Date(
                    report.court_decision_date as string,
                  ).toLocaleDateString(undefined, {
                    weekday: "long",
                    month: "long",
                    day: "numeric",
                    year: "numeric",
                  })}`}
                  mainTitle=""
                >
                  <DailyReportCard
                    key={report.id || index}
                    report={report}
                    fileRowProps={fileRowProps}
                    setIsAppealPopupOpen={setIsAppealPopupOpen}
                    prohibitionId={report.prohabition_request}
                  />
                </Accordion>
              ))}
            </div>
          </Accordion>
        )}

        {/* No Reports Message */}
        {reports.length === 0 && <p>No Prohibition Reports Added</p>}
      </div>
      <CreateAppealRequestPopup
        referralId={referralId as string}
        data={isAppealPopupOpen.data}
        isOpen={isAppealPopupOpen.open}
        onClose={() => setIsAppealPopupOpen({ open: false, data: null })}
        onSuccess={handleReportDataUpdated}
        allAssets={allFinalReportAssets}
      />
    </div>
  );
}
